// @flow
import React, { Component } from 'react'
import MediaLoaderContainer from './MediaLoaderContainer'
import type { ImageConfig } from '../types'
import { getImageSizeRestrictionsFromSingleConfig } from '../AdEdit'

type TitleParamsType = {|
  title?: string,
  fontSize?: number
|}

export type Props = {|
  onLoad: (string) => void,
  titleParams?: TitleParamsType,
  storeId: ?string,
  errors: Array<string>,
  config: ImageConfig,
  height?: number
|}

export default class AdditionalImageLoader extends Component<Props> {
  render() {
    const titleParams = this.props.titleParams
    return (
      <MediaLoaderContainer
        storeId={this.props.storeId}
        imageSizeRestrictions={getImageSizeRestrictionsFromSingleConfig(this.props.config)}
        errors={this.props.errors}
        height={this.props.height || 140}
        onLoad={(storeIds) => this.props.onLoad(storeIds[0])}
        skipMediaUpload={false}
        title={(titleParams && titleParams.title) || void 0}
        titleFontSize={titleParams && titleParams.fontSize}
        mediaType="image"
        withoutMediaPreview
      />
    )
  }
}
